import axios from 'axios';
import qs from 'qs';
import { get, set } from 'lodash';

import config from '../../config';

const redirectToLoginPage = () => {
  const url = config.sign_in_url + encodeURIComponent(window.location.href);

  window.location.replace(url);
};

const prepareError = (response) => {
  if (!response.data) {
    return response;
  }

  const msg = get(response.data, 'errors.msg');

  if (typeof msg === 'object') {
    set(response.data, 'errors.msg', undefined);
    set(response.data, 'errors.details', msg);
  }

  return response.data;
};

export const createhttp = ({ baseURL = '' }) => {
  const axiosInstance = axios.create({
    baseURL,
    paramsSerializer: (params) => qs.stringify(params, { indices: false }),
    withCredentials: true,
    headers: {
      common: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
      },
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (error.response && error.response.status === 401) {
        redirectToLoginPage();
      }
      if (axios.isCancel(error)) {
        return Promise.reject(error);
      }

      return Promise.reject(prepareError(error.response));
    },
  );

  return axiosInstance;
};

export const http = createhttp({ baseURL: config.api_url });
export const authHttp = createhttp({ baseURL: config.info_url });
export const vsosHttp = createhttp({
  baseURL: '/api/voice-settings-orchestration',
});
